export enum LoyaltyProvider {
    SPLIO = 'splio',
    COMO = 'como',
    PONGO = 'pongo',
    ZEROSIX = 'zerosix',
}
